import { IEvent } from "@quest/adapter-interface";
import { Container, Graphics, ISpineData, SpineBase, ingenuity } from "@quest/base-core";
import { BaseViewBehavior } from "@quest/murka-games-behavior-leopard/dist";
export class StickyWildViewFG extends BaseViewBehavior {
  private wildMask: Graphics;
  /** Resize */
  protected resize(evt: IEvent): void {
    //
  }
  protected initializeComponents(): void {
    super.initializeComponents();
    this.addMask();
  }
  /**
   * add mask over wild symbols
   */
  private addMask(): void {
    this.wildMask = this.getShapeById("wildReelScreenMask") as Graphics;
    this.wildMask.position.x = this.json.maskPosX;
    this.wildMask.position.y = this.json.maskPosY;

    (this.getContainerByID("WildReelFgMainContainer").mask as Graphics) = this.wildMask;
  }
  /**
   * to clone spine
   */
  public cloneSpine(): SpineBase {
    let symbolIdleSpineObj: ISpineData = ingenuity.assetsData.getJSONById("main_data").WildReelFg["WILD_1x4"];
    symbolIdleSpineObj.type = "spine";
    let SymbolSpineAnimClone: SpineBase = this.createSpine(symbolIdleSpineObj);
    SymbolSpineAnimClone.visible = true;
    // this.setAnimationTransiton(SymbolSpineAnimClone)
    return SymbolSpineAnimClone;
  }
  /**
   * to clone container
   */
  public cloneContainer(reelNo: number): Container {
    let reelContainer: any = ingenuity.assetsData.getJSONById("main_data").WildReelFg["WildReelContainer_"];
    reelContainer.id = "WildReelContainer_" + reelNo;
    reelContainer.type = "container";
    const container: Container = this.createContainer(reelContainer);
    container.visible = true;
    container.x = reelNo * this.json.wild_Width;
    return container;
  }

  /**
   * Method to set animation transition mix.
   */
  // private setAnimationTransiton(SymbolSpineAnimClone: SpineBase): void {
  //   SymbolSpineAnimClone.stateData.setMix("wild_1x4_landing_golden_frame", "wild_1x4_loop_pink_frame", 0.4);
  //   SymbolSpineAnimClone.stateData.setMix("wild_1x4_landing_golden_frame", "wild_1x4_win_pink_frame", 0.5);
  //   SymbolSpineAnimClone.stateData.setMix("wild_1x4_loop_pink_frame", "wild_1x4_loop_pink_frame", 0.5);
  //   SymbolSpineAnimClone.stateData.setMix("wild_1x4_loop_pink_frame", "wild_1x4_win_pink_frame", 0.5);
  //   SymbolSpineAnimClone.stateData.setMix("wild_1x4_win_pink_frame", "wild_1x4_loop_pink_frame", 0.5);
  // }
}
